import { render, staticRenderFns } from "./LocalDisk.vue?vue&type=template&id=72fe6a34&"
import script from "./LocalDisk.vue?vue&type=script&lang=js&"
export * from "./LocalDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72fe6a34')) {
      api.createRecord('72fe6a34', component.options)
    } else {
      api.reload('72fe6a34', component.options)
    }
    module.hot.accept("./LocalDisk.vue?vue&type=template&id=72fe6a34&", function () {
      api.rerender('72fe6a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/disks/LocalDisk.vue"
export default component.exports